export enum Sizes {
  Small = "small",
  Medium = "medium",
  Large = "large",
}
